<section class="banner">
    <img class="banner-bg" src="public/images/bg.jpg" alt="">
    <img class="banner-bg-mobile" src="public/images/bg-mobile.jpg" alt="">
    <div class="content">
        <div class="width-container">
            <h1 class="hide-mobile" [innerHtml]="'BANNER.HEAD' | translate"></h1>
            <h1 class="show-mobile" [innerHtml]="'BANNER.HEAD_MOBILE' | translate"></h1>
        </div>
        <div class="width-container">
            @if(data.REG_DATE == undefined) {
                <img [src]="assetsUrl + 'cards/MileagePlus_Card_Generic_Visa.png'" alt="United MilesagePlus Card"/>
            } @else {
                <img [src]="'CONFIRM.CARD_IMG' | translate:data"  alt="United MilesagePlus Card"/>
            }

        </div>
    </div>
</section>